
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ExchangeDialog extends _Ext.TransDialog<ExchangeRow, any> {

        protected getFormKey() { return ExchangeForm.formKey; }
        protected getIdProperty() { return ExchangeRow.idProperty; }
        protected getLocalTextPrefix() { return ExchangeRow.localTextPrefix; }
        protected getNameProperty() { return ExchangeRow.nameProperty; }
        protected getService() { return ExchangeService.baseUrl; }
        protected getDeletePermission() { return ExchangeRow.deletePermission; }
        protected getInsertPermission() { return ExchangeRow.insertPermission; }
        protected getUpdatePermission() { return ExchangeRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new ExchangeForm(this.idPrefix); 
        //ProdctImage of Items
        static image: string;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 290;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            //q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //q.setGridEditorHeight(this.form.TaxDetails, 150);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            //q.hideCaption(this.form.Posted);
            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            q.hideCaption(this.form.CustomerName);

            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });


            // **** Get Party Details using PartyID **** 
            this.form.POSCustomerId.changeSelect2(e => {
                var CUSTOMERID = this.form.POSCustomerId.value
                if (CUSTOMERID != null) {
                    if (this.form.POSCustomerId.value != null && this.form.POSCustomerId.value != "") {
                        var customerid = parseInt(this.form.POSCustomerId.value);
                        let PartyDetails;
                        OMS.PosCustomerMasterService.Retrieve({
                            EntityId: parseInt(this.form.POSCustomerId.value)
                        }, response => {
                            PartyDetails = response.Entity;
                        }, { async: false });
                        var firstname = PartyDetails.FirstName == undefined ? "" : PartyDetails.FirstName;
                        var lastname = PartyDetails.LastName == undefined ? "" : PartyDetails.LastName;
                        this.form.Address.value = PartyDetails.Address;
                        this.form.CustomerName.value = firstname + " " + lastname;
                        this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
                        this.form.GrossAmount.value = 0;

                    }
                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });
             

            q.setTextRightAlign(this.form.RoundOff);
            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value = this.form.GrossAmount.value + this.form.RoundOff.value;
            });
            //Load Image after Row in Details is Clicked
            var _this = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {

                var x: Serenity.UploadedFile = {
                    Filename: ExchangeDialog.image,
                    OriginalName: ""
                }
                _this.form.ProductItemImage.value = x;//POSSalesDialog.image;

                //Set Image Width & Height

                q.setImageEditorHeight(_this.form.ProductItemImage, 160);
            });
            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getItems().length;


                this.CalculateAmountandTax(Items);

            });

        } 
        public CalculateAmountandTax(Items: any) {

            var codearray = [];
            var amtarray = [];
            var TaxDetail = [];
            var gramt = 0; var disc = 0; var pcs = 0; var wt = 0; var nwt = 0; var ntamt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < codearray.length; i++) {
                    if (codearray[i] == x.HSN) {
                        amtarray[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                } 
                if (!temp) {
                    codearray.push(x.HSN);
                    amtarray.push(x.GrossAmount);
                } 
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;
            this.form.TaxAmount.value = TaxAmount;
            this.form.GrossAmount.value = gramt + TaxAmount;
            this.form.Pieces.value = pcs;
            this.form.Weight.value = wt;
            this.form.NetWeight.value = nwt;

        }

        protected onDialogOpen() {
            super.onDialogOpen();
            var userDefinition = Q.Authorization.userDefinition;
            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0) {
                this.form.CompanyId.value = userDefinition.CompanyId;
                this.form.FinancialYearId.value = userDefinition.FinancialYearId;
                this.form.CurrencyId.value = userDefinition.CurrencyId.toString();
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }
            if (this.form.POSCustomerId.value != null && this.form.POSCustomerId.value != "") {
                let PartyDetails;
                OMS.PosCustomerMasterService.Retrieve({
                    EntityId: parseInt(this.form.POSCustomerId.value)
                }, response => {
                    PartyDetails = response.Entity;
                }, { async: false });
                var firstname = PartyDetails.FirstName == undefined ? "" : PartyDetails.FirstName;
                var lastname = PartyDetails.LastName == undefined ? "" : PartyDetails.LastName;
                this.form.Address.value = PartyDetails.Address;
                this.form.CustomerName.value = firstname + " " + lastname;
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
                this.form.GrossAmount.value = 0;
            }
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };
            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Retail.ExchangeVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            var postingpermission = Q.Authorization.hasPermission('Retail:Exchange:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                 
                    ExchangeService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                ExchangeService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
        validateBeforeSave() {
            let Isvalid = super.validateBeforeSave();
            Isvalid = ValidateTransaction(this.form.ItemDetails.getItems(), this.form.Pieces.value, this.form.Weight.value);
            return Isvalid;
        }
     }
}